import React, { useEffect, useState } from 'react';
import { Button, Col, Drawer, Popconfirm, Row, Space, Table, Typography, Card, Tooltip } from 'antd';
import { formatDate, formatDateString, openNotification } from '../../../utils';
import TrashIcon from 'assets/icons/trash.svg';
import PenIcon from 'assets/icons/pen.svg';
import dayjs from 'dayjs';
import { APP_LOCAL_DATE_FORMAT } from 'config/constants';
import { listInspectorProfessions, deleteInspectorProfession } from '../services/inspector-professionService';
import InspectorProfessionForm from './Form';

export default function InspectorProfessionList({ referenceId }: { referenceId?: number }){
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [open, setOpen] = useState(false);
  const [editingId, setEditingId] = useState<number | undefined>();
  

  const fetchData = async () => {
    const res = await listInspectorProfessions(page-1, pageSize, 'registrationDate,desc', referenceId !== undefined ? 'accountId.equals=' + referenceId : '');
    setData(res.content);
    setTotal(res.totalElements);
  };
  useEffect(() => { if(referenceId !== undefined) fetchData(); }, [page, pageSize, referenceId]);
  const openCreate = () => { setEditingId(undefined); setOpen(true); };
  const openEdit = (id:number) => { setEditingId(id); setOpen(true); };
  const handleClose = () => setOpen(false);
  const handleDelete = async (id:number) => {
    try {
      await deleteInspectorProfession(id);
      openNotification('success', 'Başarılı', 'P.K.M Meslek Silindi');
      fetchData();
    } catch (e) {
      openNotification('error', 'Hata', 'P.K.M Meslek silme işlemi başarısız');
    }
  };
  const columns = [
    { title: 'Meslek', dataIndex: 'profession.name', sorter: true, render: (_: any, r: any) => r?.profession?.name },
    { title: 'Kayıt Numarası', dataIndex: 'registrationNumber', sorter: true },
    { title: 'Kayıt Tarihi', dataIndex: 'registrationDate', sorter: true,   render: (date: string) => formatDateString(date)},
    { title: 'Diploma No', dataIndex: 'diplomaNumber', sorter: true },
    { title: 'Mezuniyet Tarihi', dataIndex: 'graduationDate', sorter: true, render: (v: string) => v ? dayjs(v).format(APP_LOCAL_DATE_FORMAT) : '' },
    { title: 'İşlemler', render: (_:any, r:any) => (
      <Space>
        <Tooltip title='Düzenle'>
          <Button
            icon={<img src={PenIcon} alt="pen" className="icon" />}
            shape="circle"
            onClick={() => openEdit(r.id)}
            className="icon-button"
          />
        </Tooltip>
        <Popconfirm title='Sil?' onConfirm={() => handleDelete(r.id)}>
          <Tooltip title='Sil'>
            <Button
              icon={<img src={TrashIcon} alt="trash" className="icon" />}
              shape="circle"
              className="icon-button ml-12px"
            />
          </Tooltip>
        </Popconfirm>
      </Space>
    ) }
  ];
  return (
    <>
      
      <Card
        className='br-30px kontrolx-card'
        title={<Typography.Title level={4} style={{ margin: 0 }}>Meslek Bilgileri</Typography.Title>}
        extra={<Button type='primary' onClick={openCreate}>Meslek Ekle</Button>}
      >
        <Table rowKey='id' dataSource={data} columns={columns} pagination={{ current: page, pageSize, total, onChange:(p,s)=>{setPage(p); setPageSize(s);} }} />
      </Card>
      <Drawer open={open} onClose={handleClose} destroyOnClose width={480} title={editingId ? 'Meslek Düzenle' : 'Meslek Ekle'}>
        <InspectorProfessionForm id={editingId} onSuccess={() => { handleClose(); fetchData();}} referenceId={referenceId} />
      </Drawer>
    </>
  );
}
